import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dffa48f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display-item" }
const _hoisted_2 = {
  key: 1,
  class: "display-item-image"
}
const _hoisted_3 = { class: "display-items" }
const _hoisted_4 = { class: "display-item-content" }
const _hoisted_5 = { class: "display-item-header" }
const _hoisted_6 = { class: "display-item-description" }
const _hoisted_7 = { class: "qr-code" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "display-item-actions" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_UpdateCreateWalletForm = _resolveComponent("UpdateCreateWalletForm")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.walletRef.image != '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "display-item-image",
            style: _normalizeStyle({ backgroundImage: `url('${_ctx.walletRef.image}')` })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.walletRef.image == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.walletRef.name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.walletRef.type), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: 
						`https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data=${_ctx.walletRef.id}`
					,
            download: "\n\t\t\t\t\t`QRCode`\n\t\t\t\t"
          }, [
            _createElementVNode("img", {
              src: 
							`https://api.qrserver.com/v1/create-qr-code/?size=85x85&data=${_ctx.walletRef.id}`
						
            }, null, 8, _hoisted_9)
          ], 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_popover, { trigger: "click" }, {
            content: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
                icon: "pen",
                class: "menu-icon"
              }),
              _hoisted_11,
              _createVNode(_component_font_awesome_icon, {
                onClick: _ctx.onDelete,
                icon: "trash",
                class: "menu-icon"
              }, null, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "ellipsis-v",
                class: "menu-icon"
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: 'Update Wallet',
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UpdateCreateWalletForm, {
          wallet: _ctx.walletRef,
          method: "Update",
          onSaved: _ctx.changesSaved
        }, null, 8, ["wallet", "onSaved"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showDeleteModal,
      title: 'Delete Wallet',
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCancelDelete()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: "Warning",
          description: "This Wallet will be removed permanently.",
          type: "warning",
          "show-icon": ""
        }),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"10px"},
            type: "default",
            onClick: _ctx.onCancelDelete
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete(_ctx.walletRef.id, _ctx.walletRef.campaignID)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}